import PropTypes from 'prop-types';
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

const itemColorStyles = ({ palette }, isActive) => ({
  color: isActive ? palette.common.white : palette.colors.darkGrey,
});

const MenuItemsList = ({ items, ...rest }) => (
  <List {...rest}>
    {items.map(({ itemKey, title, Icon, isActive, isDisabled, handleItemClick }) => (
      <ListItem key={itemKey}>
        <ListItemButton disabled={isDisabled} onClick={handleItemClick} aria-current={isActive ? 'page' : undefined}>
          <ListItemIcon sx={(theme) => itemColorStyles(theme, isActive)} aria-hidden="true">
            <Icon />
          </ListItemIcon>

          <ListItemText
            primary={title}
            primaryTypographyProps={{
              variant: 'button',
              textAlign: 'left',
              sx: (theme) => itemColorStyles(theme, isActive),
            }}
          />
        </ListItemButton>
      </ListItem>
    ))}
  </List>
);

MenuItemsList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      itemKey: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      Icon: PropTypes.func.isRequired,
      isActive: PropTypes.bool.isRequired,
      isDisabled: PropTypes.bool.isRequired,
      handleItemClick: PropTypes.func.isRequired,
    }),
  ).isRequired,
};

export default MenuItemsList;
